import { render, staticRenderFns } from "./MitDashboardPage.vue?vue&type=template&id=dbcaf944&scoped=true"
import script from "./MitDashboardPage.vue?vue&type=script&lang=js"
export * from "./MitDashboardPage.vue?vue&type=script&lang=js"
import style0 from "./MitDashboardPage.vue?vue&type=style&index=0&id=dbcaf944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcaf944",
  null
  
)

export default component.exports